"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingOption = void 0;
/**
 * A class implementing `IStakingOption` to manage staking operations.
 */
class StakingOption {
    /**
     * Constructs a new `StakingOption` instance.
     * @param tokenAddress The address of the staking token.
     * @param tokenSymbol The symbol of the staking token.
     * @param tokenName The name of the staking token.
     * @param tokenLogoURI The URI for the logo of the staking token.
     * @param expired Indicates whether the staking option has expired.
     * @param unStakeTokenAddress The address of the token received upon unstaking.
     * @param stakingApr The annual percentage rate (APR) for staking.
     * @param tvl The total value locked in the staking contract.
     */
    constructor({ tokenAddress, tokenSymbol, tokenName, tokenLogoURI, expired, unStakeTokenAddress, stakingApr, tvl, }) {
        this.tokenAddress = tokenAddress;
        this.tokenSymbol = tokenSymbol;
        this.tokenName = tokenName;
        this.tokenLogoURI = tokenLogoURI;
        this.expired = expired;
        this.unStakeTokenAddress = unStakeTokenAddress;
        this.stakingApr = stakingApr;
        this.tvl = tvl;
    }
    /**
     * Creates a `StakingOption` instance from a JSON object.
     * @param json A JSON object containing staking option data.
     * @returns A new `StakingOption` instance.
     */
    static fromJson(json) {
        return new StakingOption({
            tokenAddress: json.tokenAddress,
            tokenSymbol: json.tokenSymbol,
            tokenName: json.tokenName,
            tokenLogoURI: json.tokenLogoURI,
            expired: json.expired,
            unStakeTokenAddress: json.unStakeTokenAddress,
            stakingApr: json.stakingApr,
            tvl: json.tvl,
        });
    }
    /**
     * Creates an array of `StakingOption` instances from an array of JSON objects.
     * @param docs An array of JSON objects each containing staking option data.
     * @returns An array of `StakingOption` instances.
     */
    static optionsFromJson(docs) {
        return docs.map(doc => StakingOption.fromJson(doc));
    }
}
exports.StakingOption = StakingOption;
